export const Kbd: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <kbd
    style={{
      fontSize: "0.75rem",
      padding: "2px 4px",
      borderRadius: 4,
      backgroundColor: "#f5f5f5",
      border: "1px solid #ccc",
      fontFamily:
        "ui-monospace, SF Mono, SF Mono-Regular, Consolas, 'Liberation Mono', Menlo, Courier, monospace",
    }}
  >
    {children}
  </kbd>
);
